var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'CustomerLevelsList'
      }
    }
  }, [_vm._v(" 會員等級列表 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" 規則設定 ")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-2 mb-xl-2 justify-content-between"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6 d-flex align-items-center"
  }, [_c('h4', {
    staticClass: "mb-2 mb-xl-0 mr-2 font-weight-bold"
  }, [_vm._v("規則設定")])]), _c('div', {
    staticClass: "\n        col-12 col-xl-6\n        d-flex\n        justify-content-start justify-content-xl-end\n      "
  }, [_vm.isShow && _vm.checkPermission([_vm.consts.CUSTOMER_LEVEL_AUTO_CHANGE_EDIT]) ? _c('b-button', {
    staticClass: "mb-2 mb-xl-0 ml-2 py-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.isShow = !_vm.isShow;
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-lead-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("編輯")]) : _vm._e()], 1)]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('section', {
    staticClass: "row mb-5"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('h4', {
    staticClass: "mb-4 text-primary"
  }, [_vm._v("會員升級條件")]), _c('small', [_vm._v("當滿足以下條件，客戶將被自動增加/升級到此會員級別:")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "升級條件",
      "label-for": "role"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "name",
      "options": _vm.roleOptions,
      "state": _vm.v$.form.base.role.$error ? false : null,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.base.role,
      callback: function callback($$v) {
        _vm.$set(_vm.form.base, "role", $$v);
      },
      expression: "form.base.role"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.base.role.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _vm.form.base.role == 2 ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每年",
      "label-for": "year-period"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-select', {
    staticClass: "mr-2",
    attrs: {
      "options": _vm.monthOptions,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.base.start_month,
      callback: function callback($$v) {
        _vm.$set(_vm.form.base, "start_month", $$v);
      },
      expression: "form.base.start_month"
    }
  }), _c('span', [_vm._v("月")]), _c('b-form-select', {
    staticClass: "mx-2",
    attrs: {
      "options": _vm.baseStartDayOptions,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.base.start_day,
      callback: function callback($$v) {
        _vm.$set(_vm.form.base, "start_day", $$v);
      },
      expression: "form.base.start_day"
    }
  }), _c('span', [_vm._v("日")]), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("~")]), _c('b-form-select', {
    staticClass: "mr-2",
    attrs: {
      "options": _vm.monthOptions,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.base.end_month,
      callback: function callback($$v) {
        _vm.$set(_vm.form.base, "end_month", $$v);
      },
      expression: "form.base.end_month"
    }
  }), _c('span', [_vm._v("月")]), _c('b-form-select', {
    staticClass: "mx-2",
    attrs: {
      "options": _vm.baseEndDayOptions,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.base.end_day,
      callback: function callback($$v) {
        _vm.$set(_vm.form.base, "end_day", $$v);
      },
      expression: "form.base.end_day"
    }
  }), _c('span', [_vm._v("日")])], 1)]) : _vm._e(), _vm.form.base.role == 3 ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "指定期限",
      "label-for": "period"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.base.period,
      callback: function callback($$v) {
        _vm.$set(_vm.form.base, "period", $$v);
      },
      expression: "form.base.period"
    }
  }), _c('b-input-group-append', [_c('b-input-group-text', [_vm._v("個月內")])], 1)], 1)], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "總消費額",
      "label-for": "amount"
    }
  }, [_c('b-input-group', {
    attrs: {
      "prepend": "NT$"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "name",
      "type": "number",
      "min": "0",
      "state": _vm.v$.form.base.amount.$error ? false : null,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.base.amount,
      callback: function callback($$v) {
        _vm.$set(_vm.form.base, "amount", $$v);
      },
      expression: "form.base.amount"
    }
  })], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.base.amount.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _c('small', [_vm._v("*注意 : 當顧客訂單完成付款後，系統將於隔日凌晨依照升級條件計算會員等級。")])], 1)]), _c('section', {
    staticClass: "row mb-5"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('h4', {
    staticClass: "mb-4 text-primary"
  }, [_vm._v("會員有效期限")]), _c('b-form-group', [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.validityOptions,
      "stacked": "",
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.validity_permanent,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "validity_permanent", $$v);
      },
      expression: "form.validity_permanent"
    }
  })], 1), _vm.form.validity_permanent == 0 ? _c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "1",
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.validity_period,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "validity_period", $$v);
      },
      expression: "form.validity_period"
    }
  }), _c('b-input-group-append', [_c('b-input-group-text', [_vm._v("個月")])], 1)], 1)], 1) : _vm._e()], 1)]), _c('section', {
    staticClass: "row mb-5"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('h4', {
    staticClass: "mb-4 text-primary"
  }, [_vm._v("會員續約條件")]), _c('small', [_vm._v("當滿足以下條件，客戶將被自動增加/升級到此會員級別:")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "續約條件",
      "label-for": "role"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "name",
      "options": _vm.roleOptions,
      "state": _vm.v$.form.renew.role.$error ? false : null,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.renew.role,
      callback: function callback($$v) {
        _vm.$set(_vm.form.renew, "role", $$v);
      },
      expression: "form.renew.role"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.renew.role.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _vm.form.renew.role == 2 ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每年",
      "label-for": "year-period"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-select', {
    staticClass: "mr-2",
    attrs: {
      "options": _vm.monthOptions,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.renew.start_month,
      callback: function callback($$v) {
        _vm.$set(_vm.form.renew, "start_month", $$v);
      },
      expression: "form.renew.start_month"
    }
  }), _c('span', [_vm._v("月")]), _c('b-form-select', {
    staticClass: "mx-2",
    attrs: {
      "options": _vm.renewStartDayOptions,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.renew.start_day,
      callback: function callback($$v) {
        _vm.$set(_vm.form.renew, "start_day", $$v);
      },
      expression: "form.renew.start_day"
    }
  }), _c('span', [_vm._v("日")]), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("~")]), _c('b-form-select', {
    staticClass: "mr-2",
    attrs: {
      "options": _vm.monthOptions,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.renew.end_month,
      callback: function callback($$v) {
        _vm.$set(_vm.form.renew, "end_month", $$v);
      },
      expression: "form.renew.end_month"
    }
  }), _c('span', [_vm._v("月")]), _c('b-form-select', {
    staticClass: "mx-2",
    attrs: {
      "options": _vm.renewEndDayOptions,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.renew.end_day,
      callback: function callback($$v) {
        _vm.$set(_vm.form.renew, "end_day", $$v);
      },
      expression: "form.renew.end_day"
    }
  }), _c('span', [_vm._v("日")])], 1)]) : _vm._e(), _vm.form.renew.role == 3 ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "指定期限",
      "label-for": "period"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.renew.period,
      callback: function callback($$v) {
        _vm.$set(_vm.form.renew, "period", $$v);
      },
      expression: "form.renew.period"
    }
  }), _c('b-input-group-append', [_c('b-input-group-text', [_vm._v("個月內")])], 1)], 1)], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "總消費額",
      "label-for": "amount"
    }
  }, [_c('b-input-group', {
    attrs: {
      "prepend": "NT$"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "name",
      "type": "number",
      "min": "0",
      "state": _vm.v$.form.renew.amount.$error ? false : null,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.renew.amount,
      callback: function callback($$v) {
        _vm.$set(_vm.form.renew, "amount", $$v);
      },
      expression: "form.renew.amount"
    }
  })], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.renew.amount.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _c('small', [_vm._v("*注意 : 當顧客訂單完成付款後，系統將於隔日凌晨依照升級條件計算會員等級。")])], 1)])]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("返回")]), !_vm.isShow ? _c('b-overlay', {
    staticClass: "d-inline-block",
    attrs: {
      "show": _vm.isLoading && !_vm.isShow,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" 確認編輯 ")])], 1) : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }